import {IntermediatePart} from "../../intermediatePart";

export default class CabinetLeg extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'cabinet_leg';
    this.partName = 'Cabinet Leg';
    this.translateId = "visualizer.laundryRoom.cabinetLeg";
    this.canBeDisabled = true;
  }

}
